import Vue from 'vue';
import Vuex from 'vuex';
import { sync } from 'vuex-router-sync';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import mixins from '@/utils/mixins.js';
import 'vuetify/dist/vuetify.min.css';
import '@/assets/css/app.scss';
import '@/registerServiceWorker';
import VueCarousel from 'vue-carousel';
import Vuetify from 'vuetify';
import fullscreen from 'vue-fullscreen';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { i18n, loadLanguageAsync } from '@/plugins/i18n';
import Meta from 'vue-meta';
import VueLazyload from 'vue-lazyload';
import VueClipboard from 'vue-clipboard2';
import Affix from 'vue-affix';
import VueAnalytics from 'vue-analytics';
import VueCookies from 'vue-cookies';
import VueSocialSharing from 'vue-social-sharing';
import func from '@/utils/globalFunctions.js';
import { FALLBACK_LANGUAGE } from '@/constants/trans';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

Vue.mixin(mixins);
Vue.use(Vuex);
Vue.use(fullscreen);
Vue.use(VueCarousel);
Vue.use(Vuetify);
Vue.use(VueAxios, axios);
Vue.use(Meta);
Vue.use(VueLazyload);
Vue.use(VueClipboard);
Vue.use(VueSocialSharing);
Vue.use(Affix);
Vue.use(VueCookies);
Vue.use(firebase);
Vue.use(VueAnalytics, { id: process.env.ANALYTICS_ID });
Vue.prototype.$func = func;

const firebaseConfig = {
  apiKey: 'AIzaSyBgfJYYeIhlm4ScPxg3qFU9Kacgs0MaenM',
  authDomain: 'super-comics.firebaseapp.com',
  databaseURL: 'https://super-comics.firebaseio.com',
  projectId: 'super-comics',
  storageBucket: 'super-comics.appspot.com',
  messagingSenderId: '53570301920',
  appId: '1:53570301920:web:d5a2ddccbf00a2ecaac585',
  measurementId: 'G-F14W1RD7VL'
};

firebase.initializeApp(firebaseConfig);
export const analytics = firebase.analytics();

Vue.filter('removeAccents', function(str) {
  let accents =
    'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  let accentsOut =
    'AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
  str = str.split('');
  str.forEach((letter, index) => {
    let i = accents.indexOf(letter);
    if (i != -1) {
      str[index] = accentsOut[i];
    }
  });
  return str.join('').replace(/ /g, '-');
});

Vue.config.productionTip = false;
sync(store, router);

axios.interceptors.request.use((config) => {
  config.baseURL = __API__;
  config.headers = config.headers || {};
  config.headers.common['api-version'] = '3';
  config.headers.common['Content-Type'] = 'application/json';
  config.headers.common['Accept-Language'] = 'en-US,en;q=0.5';
  config.headers['Accept-Language'] = window.$cookies.get('lang') || FALLBACK_LANGUAGE;

  return config;
}, Promise.reject);

axios.interceptors.response.use(response => response, async function(error) {
  const login = window.location.pathname.startsWith('/welcome/regions/');

  if (!login && error.response.status === 401) {
    this.dialog = {
      show: true,
      title: 'Erro',
      message: error.response.message,
      ok: () => {
        this.dialog.show = false;
      }
    };

    store.commit('logout');

    const lastPageLogin = await Vue.cookies.get('scloginpage');
    let routeName = ['neo', 'isp'].includes(lastPageLogin)
      ? lastPageLogin
      : 'welcome';

    router.push({ name: routeName });
  }

  return Promise.reject(error);
});

loadLanguageAsync(Vue.cookies.get('lang'));

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
